<template>
  <!-- 大学生健康检查表  -->
  <div v-if="model && model.university">
    <div id="print_university" class="page university-page">
      <div style="display: flex;font-size: 25px;text-align: center;font-weight: 600;">
        <table style="width: 100%;border-collapse: collapse;border:none;letter-spacing: 5px;">
          <tbody>
          <tr style="width: 100%;border-collapse: collapse;border:none;">
            <td style="border-collapse: collapse;border:none;">{{ model.university.hospitalName ? model.university.hospitalName : "" }}</td>
          </tr>
          <tr style="width: 100%;border-collapse: collapse;border:none;">
            <td style="border-collapse: collapse;border:none;">{{ model.university.reportName ? model.university.reportName : "大学生健康检查表" }}</td>
          </tr>
          </tbody>
        </table>
        <!--
        <div>
          <div>
            <img :src="model.university.barCodeImage" style="width: 100%; height: 100%;"/>
          </div>
          <div style="line-height: 0px;font-size: 15px;letter-spacing: 0px;" v-if="model.university.barCodeImage">{{model.university.barCode}}</div>
        </div>
        -->
      </div>

      <table style="padding-left: 10px;text-align: left;width: 100%;margin-top:10px;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 30px;">
            <td colspan="5" style="width: 65%;border-collapse: collapse;border:none;">学校：<span>{{ model.university.schoolName ? model.university.schoolName : "" }}</span></td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border:none;">检查日期：<span>{{ model.university.checkDate ? model.university.checkDate : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td colspan="5" style="width: 65%;border-collapse: collapse;border:none;">班级：<span>{{ model.university.className ? model.university.className : "" }}</span></td>
            <td colspan="2" style="border-collapse: collapse;border:none;">序&nbsp;&nbsp;列&nbsp;号：<span>{{ model.university.serialNumber ? model.university.serialNumber : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="text-align: center;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">姓名</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.name ? model.university.name : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">性别</td><td style="width: 70px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.sex ? model.university.sex : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">民族</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.nation ? model.university.nation : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">出生日期</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.birthday ? model.university.birthday : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">学历层次</td><td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.education ? model.university.education : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">联系电话</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.phone ? model.university.phone : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">身份证号</td><td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.idcard ? model.university.idcard : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;"><td style="width: 70px;border-collapse: collapse;border: 1px solid black;">既往病史</td><td colspan="6" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.pastMedicalHistory ? model.university.pastMedicalHistory : "" }}</span></td></tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">过敏史</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.allergyHistory ? model.university.allergyHistory : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">家族史</td><td colspan="3" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.familyHistory ? model.university.familyHistory : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td rowspan="2" style="width: 70px;border-collapse: collapse;border: 1px solid black;">一般情况</td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">身高</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.height ? model.university.height : "" }}</span><span style="float:right;margin-right: 15px">cm</span></td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">体重</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.weight ? model.university.weight : "" }}</span><span style="float:right;margin-right: 15px">kg</span></td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">BMI</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.bmi ? model.university.bmi : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">脉搏</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.pulse ? model.university.pulse : "" }}</span><span style="float:right;margin-right: 15px">次/分</span></td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">血压</td><td colspan="4" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.systolicPressure ? model.university.systolicPressure : "" }}</span>/<span>{{ model.university.diastolicPressure ? model.university.diastolicPressure : "" }}</span><span style="float:right;margin-right: 15px">mmHg</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td rowspan="2" style="width: 70px;border-collapse: collapse;border: 1px solid black;">裸眼视力</td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">左</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.nakedLeftEyeVision ? model.university.nakedLeftEyeVision : "" }}</span></td>
            <td rowspan="2" style="width: 70px;border-collapse: collapse;border: 1px solid black;">矫正视力</td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">左</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.correctLeftEyeVision ? model.university.correctLeftEyeVision : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">右</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.nakedRightEyeVision ? model.university.nakedRightEyeVision : "" }}</span></td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">右</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.correctRightEyeVision ? model.university.correctRightEyeVision : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td rowspan="4" style="width: 70px;border-collapse: collapse;border: 1px solid black;">五官科</td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">眼底</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.fundus ? model.university.fundus : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">听力</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.hearing ? model.university.hearing : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">咽喉</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.pharynx ? model.university.pharynx : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">口腔</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.oralCavity ? model.university.oralCavity : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">辨色力</td><td colspan="5" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.distinguishColour ? model.university.distinguishColour : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="5" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.facialFeaturesOther ? model.university.facialFeaturesOther : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td rowspan="5" style="width: 70px;border-collapse: collapse;border: 1px solid black;">内科</td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">营养发育</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.development ? model.university.development : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">神经精神</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.neuropsychology ? model.university.neuropsychology : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">呼吸系统</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.systemBreathing ? model.university.systemBreathing : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">循环系统</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.systemLoop ? model.university.systemLoop : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">肝胆</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.liverAndGallbladder ? model.university.liverAndGallbladder : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">脾脏</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.spleen ? model.university.spleen : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">肾脏</td><td colspan="5" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.kidney ? model.university.kidney : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="5" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.insideOther ? model.university.insideOther : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td rowspan="4" style="width: 70px;border-collapse: collapse;border: 1px solid black;">外科</td>
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">皮肤</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.skin ? model.university.skin : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">淋巴</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.lymph ? model.university.lymph : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">甲状腺</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.thyroid ? model.university.thyroid : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">脊椎</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.spine ? model.university.spine : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">四肢</td><td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.limb ? model.university.limb : "" }}</span></td>
            <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">关节</td><td colspan="2" style=" width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.joint ? model.university.joint : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="5" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.surgeryOther ? model.university.surgeryOther : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">X线检查</td><td colspan="6" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.xray ? model.university.xray : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">化验检查</td><td colspan="6" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.laboratoryExamination ? model.university.laboratoryExamination : "" }}</span></td>
          </tr>
          <tr style="line-height: 30px;">
            <td style="width: 70px;height: 110px;border-collapse: collapse;border: 1px solid black;">检查结论</td>
            <td colspan="4" style="word-wrap: break-word;overflow: auto;flex-wrap: wrap;justify-content: flex-start;border-collapse: collapse;border: 1px solid black;"><span>{{ model.university.inspectionResults ? model.university.inspectionResults : "" }}</span></td>
            <td style="width: 70px;height: 110px;border-collapse: collapse;border: 1px solid black;">医师签名</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><img :src="model.university.doctorSignature" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.university.doctorSignature"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import {_university} from "@/services/report/report";
export default {
  name: "universityReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        university:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'university'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'university') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.university(this.barCode);
      }
    },
    university(barCode) {
      _university({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        /*if(this.model.university.barCodeImage){
          this.drawBase64ToCanvas(this.model.university.barCodeImage);
        }*/
      })
    },
    drawBase64ToCanvas (base64String) {
      const canvas = this.$refs.barcodeImage;
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // 设置Canvas尺寸与图片一致
        canvas.width = img.width;
        canvas.height = img.height;
        // 绘制图片
        ctx.drawImage(img, 0, 0);
      };

      img.onerror = () => console.error("图片加载失败");
      img.src = base64String;
    }
  }
}
</script>
<style lang="postcss" scoped>
@media print {
  .university-page {
    page: university-page; /* 绑定唯一命名 */
  }
  @page university-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:30px;padding-left:25px;padding-right:25px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff; font-size: 15px;}


</style>

